import { render, staticRenderFns } from "./author-details-edit.html?vue&type=template&id=753b91d5&scoped=true&"
import script from "./author-details-edit.js?vue&type=script&lang=js&"
export * from "./author-details-edit.js?vue&type=script&lang=js&"
import style0 from "./author-details-edit.scss?vue&type=style&index=0&id=753b91d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753b91d5",
  null
  
)

export default component.exports